export const timelineData = [
  {
    id: 1,
    year: "2024",
    title: "Senior Developer for AI Government Contract using vision AI for meeting analysis",
    company: "Government Contract (NDA)",
    description: "Developed vision AI solution for government client to analyze meetings. Implemented AI-powered speech analysis, summarization, and visual cue detection. Utilized computer vision models to provide real-time insights and automated reporting.",
    category: "Career",
    icon: "🔒",
    color: "#2563eb"
  },
  {
    id: 3,
    year: "2025",
    title: "Architected habit-tracking app generating $15k/mo for sobriety influencer",
    company: "Odessa",
    link: "https://apps.apple.com/us/app/odessa-quit-weed/id6751055584",
    description: "Creator wanted to monetize large Instagram audience through mobile app. Leveraged prior expertise in habit-forming apps to recommend top 3 features with daily usage frequency. Suggested main viral loops for Product-Led-Growth success. Hired designer for Figma mockups optimized for paywall conversions. Personally built app in React Native + Firebase Functions. Launched in 2 months. Currently generates $15k/mo revenue with 28% paywall conversion, 45% daily active users, 4.9 rating.",
    category: "Career",
    icon: "🧠",
    color: "#2563eb",
    screenshots: ["/odessa0.png", "/odessa1.png", "/odessa2.png", "/odessa3.png"]
  },
   {
    id: 42,
    year: "2025",
    title: "Architected AI-powered video discovery tool for content marketers",
    company: "99creators.com",
    description: "Client, a Twitter business influencer, needed a solution for content marketers to find viral video inspiration. Architected and developed platform that scraped 65,000+ viral TikToks of apps and ecommerce products. Enriched data using Google Gemini AI API to detect scene changes, making it easier to edit videos. Built advanced search/filter system, bookmarking, and discovery features.",
    category: "Career",
    icon: "🎬",
    link: "https://99creators.com",
    color: "#2563eb",
    noIphone: true,
    screenshots: ["/99creators1.png", "/99creators2.png", "/99creators3.png"]
  },
  {
    id: 4,
    year: "2025",
    title: "Built AI nutrition app to manage my dogs' homemade meals and gut health",
    company: "PawsAI - App Store",
    description: "Personal project to better track my own dogs' nutrition. React Native + Firebase Functions. Integrated OpenAI vision API to analyze food images and provide nutritional insights for balanced homemade diets.",
    category: "Entrepreneurship",
    icon: "🐕",
    link: "https://apps.apple.com/us/app/paws-ai/id6670763544",
    color: "#ea580c",
        screenshots: ["/paws1.png", "/paws2.png", "/paws3.png", "/paws4.png"]
  },
  {
    id: 41,
    year: "2020",
    title: "Built a mobile app that sort by distance 15k farms selling direct to consumer meats + produce.",
    company: "SimplyLocal - Farmers Market (acquired)",
    description: "Sold it in January 2025. 300k+ users. 4.8 App rating. Scraped online website resources to package into mobile app. Used public datasets from USADA. Enriched + cleaned data using AI.",
    category: "Entrepreneurship",
    icon: "🚜",
    color: "#ea580c",
    screenshots: ["/sl1.png", "/sl2.png", "/sl3.png", "/sl4.png"]
  },
 
  {
    id: 993,
        year: "2019",
    title: "Led React Native team rebuilding Neurocycle (1m+ install therapy app for 3m+ influencer)",
    company: "Neurocycle",
    description: "Managed team of developers rebuilding Neurocycle, a React Native app for influencer in therapy/neuro-education space. Architected solutions to fix critical bugs while maintaining user experience. Improved conversion rate drastically through strategic UX improvements.",
    category: "Career",
    icon: "👥",
    color: "#2563eb",
  },

   {
    id: 322,
        year: "2020",
    title: "Architected POS-integrated apps for major food chains (Popeyes, Payless - 1m+ installs each)",
    company: "NDA Dev Agency",
    description: "Led technical architecture for 2 major food chain mobile apps. Owned POS integration - the most technically complex aspect. Collaborated closely with design team to implement world-class UI/UX. Delivered on time with 1m+ installs each.",
    category: "Career",
    icon: "👥",
    color: "#2563eb"
  },

  {
    id: 999,
        year: "2018",
    title: "Lead mobile developer (React Native) for top app in Hunting subcategory.",
    company: "SpireDigital Dev Agency",
    description: "A react-native app built with Mapbox for data set layering. Offline capability - used for hunting in public / private land. Extensive optimization. Excellent UX",
    category: "Career",
    icon: "🗺️",
    color: "#2563eb",
    
  },
  {
    id: 6,
    year: "2018",
    title: "Built short form video recipes mobile app before Buzzfeed Tasty released theirs.",
    company: "Flavorsome",
    description: "A react-native app built with Firebase Functions backend, used transcribed video recipes to create grocery lists. 5,000 users. 4.3 app rating. Side project.",
    category: "Career",
    icon: "🍳",
    color: "#2563eb"
  },
   {
    id: 99,
        year: "2018",
    title: "Built a mobile app that told you what aisle your grocery items were on for HEB grocery stores in Central Texas",
    company: "Flavr",
    description: "A react-native app built with Firebase Functions backend, used web scraped data on aisle information from their website to package a mobile app with aisle instructions. They released the feature themselves soon after.",
    category: "Career",
    icon: "🛒",
    color: "#2563eb",
    noIphone: true,
        screenshots: ["/flavr.png"]

  },
  {
    id: 7,
    year: "2018",
    title: "Started web magazine in college creating viral Instagram inforgraphics for Twitter. Sold to blogger (2018).",
    company: "Cannahacker.com",
    description: "Grew to 300,000 monthly visitors to the site. 18,000 email list. Failed to monetize using ads compared to time it consumed to create content. Eventually sold it to writer Zach Schwartz.",
    category: "Entrepreneurship",
    icon: "📰",
    color: "#ea580c"
  },
  {
    id: 9,
    year: "2016",
    title: "Computer Science BS",
    company: "Texas A&M University-College Station",
    description: 'Member of Aggies School Startup Incubator with SaaS called CurateKing - a social media scheduling tool for Twitter. Featured in <a href="https://www.bizjournals.com/austin/print-edition/2014/08/01/round-rock-startup-helps-businesses-wrangle-social.html" target="_blank" rel="noopener noreferrer">Austin Business Journal</a>.',
    category: "Education",
    icon: "🎓",
    color: "#059669",
    screenshots: ["/curateking.jpg"]
  }
];

export const categories = {
  Career: { color: "#2563eb", bgColor: "#dbeafe" },
  Education: { color: "#059669", bgColor: "#d1fae5" },
  Achievement: { color: "#dc2626", bgColor: "#fee2e2" },
  Certification: { color: "#7c3aed", bgColor: "#ede9fe" },
  Entrepreneurship: { color: "#ea580c", bgColor: "#fed7aa" },
  Personal: { color: "#0891b2", bgColor: "#cffafe" }
};